'use client';

import React from 'react';
import { Input } from 'src/components/PulseUI';

export interface ConfigCardProps {
  tag?: string;
  title: string;
  criteriaContent: React.ReactNode;
  inputLabel: string;
  inputValue: string;
  textareaValue: string;
  onInputChange: (value: string) => void;
  onTextareaChange: (value: string) => void;
  extraInfo?: React.ReactNode;
}

const ConfigCard: React.FC<ConfigCardProps> = ({
  tag,
  title,
  criteriaContent,
  inputLabel,
  inputValue,
  textareaValue,
  onInputChange,
  onTextareaChange,
  extraInfo,
}) => (
  <div
    className="flex flex-col gap-3 rounded-lg bg-neutral-50 p-4"
    data-testid="config-card"
  >
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        {tag && (
          <span className="rounded-full bg-violet-50 px-2 py-0.5 text-xs font-medium text-violet-700">
            {tag}
          </span>
        )}
        <h4 className="font-semibold text-primary">{title}</h4>
      </div>
    </div>
    <div className="rounded-lg bg-neutral-100 p-3">{criteriaContent}</div>
    {extraInfo && <div className="text-xs text-tertiary">{extraInfo}</div>}
    <div className="flex flex-col gap-1">
      <Input
        type="text"
        value={inputValue}
        onChange={(e) => onInputChange(e.target.value)}
        fullWidth
        aria-label={inputLabel}
        data-testid={`${inputLabel.toLowerCase().replace(/\s+/g, '-')}-input`}
        placeholder="Name"
      />
    </div>
    <div className="flex flex-col gap-1">
      <textarea
        value={textareaValue}
        onChange={(e) => onTextareaChange(e.target.value)}
        rows={2}
        className="w-full resize-y rounded-lg border border-neutral-200 bg-white px-4 py-3 text-sm focus:border-violet-500 focus:outline-none focus:ring-1 focus:ring-violet-500"
        aria-label={`${inputLabel} description`}
        data-testid={`${inputLabel.toLowerCase().replace(/\s+/g, '-')}-description`}
        placeholder="Description"
      />
    </div>
  </div>
);

export default ConfigCard;
